<template>
  <div class="container">
    <h2>BedBoard Application</h2>
    <p>Version {{ appVersion }}</p>
    <p>Scope {{ scopeID }}</p>
    <!-- <v-btn class="ntstAppButton" @click.stop="refreshToken()">
      Refresh Token
    </v-btn> -->

  </div>
</template>


<script lang="js">
import moment from 'moment';

import appSettings from '../appSettings';

import bedBoardUtils from '../bedBoardUtils';

export default {
  name: 'App',
  data() {
    return {
      appVersion: process.env.VUE_APP_VERSION,
      scopeID: this.$store.getters.scopeID
    };
  },
  methods: {
    refreshToken() {
      try {
        this.$log.debug(`[${moment().format(appSettings.logDateFormat)}] Refreshing token...`);
        bedBoardUtils.executeRefreshToken()
          .then((loginParameters) => {
            this.$sdkAuth.updateNtstOAuthTokenData(loginParameters.ntstOAuthTokenData, 'session');
            this.$log.debug(`[${moment().format(appSettings.logDateFormat)}] Token successfully refreshed.`);
          })
          .catch((err) => {
            this.$log.error(`[${moment().format(appSettings.logDateFormat)}] Error encountered executing refresh token: ${err.message}`);
            this.errorMessage = err.message;
            this.isBusy = false;
          });
      } catch (err) {
        this.$log.error(`[${moment().format(appSettings.logDateFormat)}] Error encountered refreshing token: ${err.message}`);
        this.isBusy = false;
      }
    }
  }
};
</script>
